import React from 'react';

import CustomerModel from 'models/CustomerModel';
import Modal from 'components/common/Modal';
import CustomerSearch from 'components/common/CustomerSearch';
import { FaUser } from 'react-icons/fa';
import Customer from 'models/CustomerModel';
import { Car, MessageSquareTextIcon, X } from 'lucide-react';

interface Props {
    onClose: (customer?: Customer) => void;
}

interface ComponentState {
    modalHeader: string;

    customerId: string | undefined;
    customer: Customer | undefined;

    isFormExpanded: boolean;
}

class CustomerPickerModal extends React.Component<Props, ComponentState> {
    constructor(props: Props) {
        super(props);

        this.state = {
            modalHeader: '',
            customerId: undefined,
            customer: undefined,

            isFormExpanded: false,
        };

        this.getValue = this.getValue.bind(this);
        this.handleCustomerSelected = this.handleCustomerSelected.bind(this);
    }

    componentDidMount() {
        this.setState({ modalHeader: 'Start a new chat' });
    }

    getValue(name: string) {
        // @ts-ignore
        return this.state.appointment[name] || '';
    }

    handleCustomerSelected(customer?: CustomerModel) {
        if (customer) {
            this.setState({ customerId: customer.id, customer });
        } else {
            this.setState({
                customerId: undefined,
            });
        }
    }

    render() {
        // prettier-ignore
        const {
            modalHeader,
            customerId,
            customer
        } = this.state;
        return (
            <Modal
                // onDelete={modalState === ModalStateType.Edit ? this.delete : undefined}
                headerText={modalHeader}
                isOpen={true}
                onClose={() => this.props.onClose()}
                isBackgroundWhite={true}
                isWithFooter={false}
                customHeader={
                    <div className="bg-blue-600 text-white p-2 flex items-center justify-between w-full">
                        <div className="flex items-center gap-3">
                            <div className="p-2 bg-white rounded-lg">
                                <MessageSquareTextIcon className="w-5 h-5 text-blue-600" />
                            </div>
                            <h2 className="text-xl font-semibold text-white">{modalHeader}</h2>
                        </div>
                        <button
                            className="text-white hover:bg-blue-700 p-1 rounded"
                            onClick={() => this.props.onClose()}
                        >
                            <X size={24} />
                        </button>
                    </div>
                }
            >
                <div className="w-full bg-white">
                    <div className="pt-2 pb-96">
                        <div className="items-baseline flex font-semibold text-sm uppercase">
                            <FaUser className="inline mr-1.5" />
                            <h3>{!customerId ? 'Select a customer' : 'Selected customer'}</h3>
                        </div>

                        <CustomerSearch
                            customerSelected={this.handleCustomerSelected}
                            displayDetailsWhenSelected={true}
                        />
                        {!!!customerId && (
                            <div>
                                <span className="font-semibold text-gray-600">No customer selected</span>
                            </div>
                        )}
                    </div>
                    <div className="mt-auto flex *:justify-end w-full">
                        <button
                            className="py-2 px-6 rounded-lg bg-gray-200 hover:bg-gray-300 text-gray-700 font-semibold text-center mr-4 w-1/2"
                            onClick={() => this.props.onClose()}
                        >
                            Cancel
                        </button>
                        <button
                            disabled={!customerId}
                            className={`py-2 px-6 rounded-lg bg-blue-500 hover:bg-blue-600 disabled:bg-blue-300 text-white font-semibold text-center w-1/2 ${
                                !customerId ? 'cursor-none' : 'cursor-pointer'
                            }`}
                            onClick={() => this.props.onClose(customer)}
                        >
                            Start Chat
                        </button>
                    </div>
                </div>
            </Modal>
        );
    }
}

export default CustomerPickerModal;
